import axios from "axios";

export default function getPrifeReceiveTransferReceiverDropdown(params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/prife/transfer/get-receiver-dropdown`, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
